
export default {
    name: 'LeeTag',
    data() {
        return {}
    },
    inject: ['taggroup'],
    mounted() {

    },
    methods: {
        del(item) {
            let xh = this.taggroup.tags.indexOf(item)
            this.taggroup.tags.splice(xh, 1)
        },
        tonum(str) {
            switch (str) {
                case 'a':
                case 'A':
                    str = 10
                    break;
                case 'b':
                case 'B':
                    str = 11
                    break;
                case 'c':
                case 'C':
                    str = 12
                    break;
                case 'd':
                case 'D':
                    str = 13
                    break;
                case 'e':
                case 'E':
                    str = 14
                    break;
                case 'f':
                case 'F':
                    str = 15
                    break;
            }
            return str
        },
        torgb(color) {
            var color = color.split('#')[1]
            var r = color.slice(0, 2)
            var r1 = r.slice(0, 1)
            var r2 = r.slice(1, 2)
            var g = color.slice(2, 4)
            var g1 = g.slice(0, 1)
            var g2 = g.slice(1, 2)
            var b = color.slice(4, 6)
            var b1 = b.slice(0, 1)
            var b2 = b.slice(1, 2)
            var R = Number(this.tonum(r1) * 16) + Number(this.tonum(r2))
            var G = Number(this.tonum(g1) * 16) + Number(this.tonum(g2))
            var B = Number(this.tonum(b1) * 16) + Number(this.tonum(b2))
            return {R: R, G: G, B: B}
        },
        bg(color) {
            if (color == undefined) {
                color = "#46bd87"
            }
            var R = this.torgb(color).R
            var G = this.torgb(color).G
            var B = this.torgb(color).B
            return 'rgba(' + R + ',' + G + ',' + B + ',.1)'


        },
        bor(color) {
            if (color == undefined) {
                color = "#46bd87"
            }
            var R = this.torgb(color).R
            var G = this.torgb(color).G
            var B = this.torgb(color).B
            return 'rgba(' + R + ',' + G + ',' + B + ',.2)'


        },
        cor(color) {
            if (color == undefined) {
                color = "#46bd87"
            }
            var R = this.torgb(color).R
            var G = this.torgb(color).G
            var B = this.torgb(color).B
            return 'rgb(' + R + ',' + G + ',' + B + ')'


        }

    },
    props: {
        item: {
            type: Object,
            default() {
                return {}
            }
        }
    }
};
